import { render, staticRenderFns } from "./ExhibitList.vue?vue&type=template&id=105e4d26&scoped=true&"
import script from "./ExhibitList.vue?vue&type=script&lang=js&"
export * from "./ExhibitList.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitList.vue?vue&type=style&index=0&id=105e4d26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105e4d26",
  null
  
)

export default component.exports